import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPriceTransparency = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.19971 7.00073H10.1997"
          stroke="currentColor"
          strokeWidth={1.12499}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.19971 10.9991H7.1997"
          stroke="currentColor"
          strokeWidth={1.12499}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.19971 14.9999L7.1997 14.9999"
          stroke="currentColor"
          strokeWidth={1.12499}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.1763 14.4097C13.3186 14.5969 13.504 14.7469 13.7167 14.8471C13.9293 14.9473 14.1631 14.9946 14.398 14.9851C15.1469 14.9851 15.7538 14.5294 15.7538 13.9679C15.7538 13.4063 15.1469 12.9507 14.398 12.9507C13.6491 12.9507 13.0415 12.495 13.0415 11.9328C13.0415 11.3706 13.6491 10.9156 14.398 10.9156C14.6329 10.9062 14.8666 10.9536 15.0793 11.0537C15.2919 11.1539 15.4773 11.3039 15.6197 11.4909"
          stroke="currentColor"
          strokeWidth={1.12499}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3979 14.9855V15.6627"
          stroke="currentColor"
          strokeWidth={1.12499}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3979 10.2394V10.9166"
          stroke="currentColor"
          strokeWidth={1.12499}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.7999 20.9999C13.9835 20.6854 14.2463 20.4244 14.5621 20.243C14.8779 20.0616 15.2357 19.9662 15.5999 19.9662C15.9641 19.9662 16.322 20.0616 16.6378 20.243C16.9536 20.4244 17.2164 20.6854 17.3999 20.9999V17.4999M10.2 20.9999C10.0164 20.6854 9.75365 20.4244 9.43783 20.243C9.12201 20.0616 8.76417 19.9662 8.39997 19.9662C8.03578 19.9662 7.67794 20.0616 7.36212 20.243C7.0463 20.4244 6.78353 20.6854 6.59998 20.9999C6.41644 20.6854 6.15367 20.4244 5.83785 20.243C5.52203 20.0616 5.16419 19.9662 4.79999 19.9662C4.4358 19.9662 4.07796 20.0616 3.76214 20.243C3.44632 20.4244 3.18354 20.6854 3 20.9999V3C3.18395 3.31426 3.44679 3.57501 3.76251 3.75644C4.07823 3.93787 4.43586 4.03369 4.79999 4.0344C5.16411 4.03361 5.52171 3.93776 5.83741 3.75634C6.15311 3.57491 6.41597 3.3142 6.59998 3C6.78393 3.31426 7.04678 3.57501 7.36249 3.75644C7.67821 3.93787 8.03584 4.03369 8.39997 4.0344C8.76409 4.03361 9.12169 3.93776 9.4374 3.75634C9.7531 3.57491 10.016 3.3142 10.2 3C10.3839 3.31426 10.6468 3.57501 10.9625 3.75644C11.2782 3.93787 11.6358 4.03369 12 4.0344C12.3641 4.03361 12.7217 3.93776 13.0374 3.75634C13.3531 3.57491 13.6159 3.3142 13.7999 3C13.9839 3.31426 14.2467 3.57501 14.5625 3.75644C14.8782 3.93787 15.2358 4.03369 15.5999 4.0344C15.9641 4.03361 16.3217 3.93776 16.6374 3.75634C16.9531 3.57491 17.2159 3.3142 17.3999 3V8.49998"
          stroke="currentColor"
          strokeWidth={1.12499}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2002 21C10.3837 20.6855 10.6465 20.4245 10.9623 20.2431C11.2782 20.0618 11.636 19.9663 12.0002 19.9663C12.3644 19.9663 12.7222 20.0618 13.038 20.2431C13.3539 20.4245 13.6166 20.6855 13.8002 21"
          stroke="currentColor"
          strokeWidth={1.12499}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.37838 15.0233C9.93185 16.3256 10.98 17.3548 12.2922 17.8843C13.6045 18.4138 15.0733 18.4003 16.3757 17.8469C17.678 17.2934 18.7071 16.2452 19.2366 14.933C19.7661 13.6207 19.7527 12.1519 19.1992 10.8496C18.6457 9.54726 17.5976 8.51814 16.2853 7.98862C14.9731 7.45911 13.5042 7.47257 12.2019 8.02604C10.8996 8.57952 9.87048 9.62766 9.34096 10.9399C8.81144 12.2522 8.8249 13.721 9.37838 15.0233V15.0233Z"
          stroke="currentColor"
          strokeWidth={1.12999}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.062 16.7081L22.2 20.8467"
          stroke="currentColor"
          strokeWidth={1.12999}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPriceTransparency.displayName = 'SvgPriceTransparency';
export default SvgPriceTransparency;
